export const POINTS_TO_MIRAI_MILE_RATIO = 10; // 1 point = 10 mirai miles -> 変更する
export const YEN_TO_MIRAI_MILE_RATIO = 100; // 1 yen = 100 mirai miles

export const POINTS_TO_YEN_RATIO = POINTS_TO_MIRAI_MILE_RATIO / YEN_TO_MIRAI_MILE_RATIO;

export const pointsToYen = (points: string | number, isDisplayedDecimal = false): string => {
  const num = Number(points);
  if (Number.isNaN(num)) {
    return points.toString();
  }

  const yenValue = num * POINTS_TO_YEN_RATIO; // Convert points to yen
  if (isDisplayedDecimal) {
    if (yenValue < 1) {
      return yenValue.toFixed(1); // Return unrounded value with one decimal place
    }
  }

  return Math.floor(yenValue).toLocaleString();
};

export const pointsToYenForCalculations = (points: string | number): number => {
  const num = Number(points);
  if (Number.isNaN(num)) {
    return 0;
  }
  const yenValue = num * POINTS_TO_YEN_RATIO;
  return Math.floor(yenValue);
};

export const yenToPoints = (yen: number): number => {
  return Math.floor(yen / POINTS_TO_YEN_RATIO);
};
